/*
	import { listAmenities } from '@/services/Amenities/Amenity/List';

  const { list, successful, message } = await listAmenities ({
    params: {
			hoaID
    }
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import _get from 'lodash/get'
import kms from '@/services/kms'

export async function listAmenities({ params }) {
  let message = 'The amenities list could not be retrieved.'

  try {
    const result = await kms.get(`/Amenities/Amenity/List`, {
      params
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message,
      list
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    list: []
  }
}
